import { css } from 'aphrodite';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { useEventLogging } from '../../../../models/Logging';
import {
	selectBoundEmailExecTemplate,
	useEmailExecAssistantTemplatesQuery,
} from '../../../../queries/EmailExecAssistant/useEmailExecTemplates';
import { Button } from '../../../components-v2/Button';
import { ROUTES } from '../../../constants/routes';
import { MailSparkleIcon } from '../../svgs/icons/MailSparkleIcon';
import { XIconNew } from '../../svgs/icons/XIcon';
import { DashboardCard, DashboardCardHeaderLabel } from '../DashboardCard';
import { useFeatureCard } from '../DashboardCustomContentCard/useFeatureCard';
import { styleSheet } from './styles';

const TELEMETRY_CATEGORY = 'DashboardInboxAssistantPromoCard';

export const DashboardInboxAssistantPromoCard: FC = () => {
	const userSession = useUserSession();
	const history = useHistory();
	const { logEvent } = useEventLogging(TELEMETRY_CATEGORY);
	const { showCard, onClose } = useFeatureCard({ cardName: 'email-exec-dashboard-card' });

	const enabled = !!userSession.account?.features?.emailExec?.enabled;
	const templatesQuery = useEmailExecAssistantTemplatesQuery({ enabled: enabled && showCard });

	if (!enabled || !showCard || templatesQuery.isPending || templatesQuery.isError) {
		return null;
	}

	if (selectBoundEmailExecTemplate(templatesQuery.data ?? [])) {
		return null;
	}

	return (
		<DashboardCard styleDeclaration={styleSheet.card}>
			<div className={css(styleSheet.cardHeader)}>
				<DashboardCardHeaderLabel styleDeclaration={styleSheet.headerContent}>
					<span className={css(styleSheet.icon)}>
						<MailSparkleIcon />
					</span>
					<span className={css(styleSheet.title)}>Meet your Inbox Assistant</span>
				</DashboardCardHeaderLabel>
				<Button
					variant='ghost'
					size='icon'
					onClick={() => {
						logEvent('PromoDismissed');
						onClose();
					}}
				>
					<XIconNew />
				</Button>
			</div>
			<div className={css(styleSheet.body)}>
				<p className={css(styleSheet.description)}>
					A daily brief of what matters in your inbox — monitored keywords, follow-ups waiting on you, and reply drafts
					ready to send.
				</p>
				<div className={css(styleSheet.actions)}>
					<Button
						size='sm'
						onClick={() => {
							logEvent('SetUpClicked');
							history.push(ROUTES.emailExec.settings);
						}}
					>
						Set up your assistant
					</Button>
				</div>
			</div>
		</DashboardCard>
	);
};
